import React from 'react';

const Section = ({ title, kicker, description, children, className = '' }) => {
  return (
    <section className={`support-section ${className}`}>
      <div className="support-container animate-fade-in-up">
        {kicker && <p className="section-kicker">{kicker}</p>}
        {title && <h2 className="section-title">{title}</h2>}
        {description && <p className="section-description">{description}</p>}
        {children}
      </div>
    </section>
  );
};

export default Section;
